var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"help-link",attrs:{"href":_vm.fullRoute,"target":"_blank"}},[(!_vm.hideIcon)?_c('v-icon',{attrs:{"small":"","color":"primary"}},[_vm._v("help")]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }